<div class="row no-gutters mb-3 mb-submit-box-terms">
  <ng-container *ngIf="isTypeACheckout">
    <form [formGroup]="termsOfUseForm"
        class="col-12">
      <div class="mb-custom-checkbox" data-cy="mb-submit-order-terms-of-use">
        <label class="m-0 mb-terms-label"
               for="termsOfUse">
          <input type="checkbox"
                 formControlName="termsOfUse"
                 id="termsOfUse">
            <span class="mb-label">
              <span> {{'submitBox.confirmThatRead' | cxTranslate}}</span>
                <a class="mb-terms-link" href="https://www.miltenyibiotec.com/legal-notes.html#termsofuse"
                   target="_blank"><span>{{'submitBox.termsOfUse' | cxTranslate}}</span></a>
            </span>
        </label>
        <mb-form-errors [control]="termsOfUseForm?.get(constants.TERMS_OF_USE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </form>


  </ng-container>

  <form [formGroup]="termsConditionsForm"
        [ngClass]="['col-12', isTypeACheckout? 'mb-margin-top' : '']"
        data-cy="mb-terms-condition-form">
    <div class="mb-custom-checkbox" data-cy="mb-submit-order-terms-and-condition">
      <label class="m-0 mb-terms-label"
             for="termsAndConditions">
      <input type="checkbox"
             formControlName="termsAndConditions"
             id="termsAndConditions">

        <span class="mb-label">
          <span> {{'submitBox.confirmThatRead' | cxTranslate}}</span>
          <a class="mb-terms-link" href="https://www.miltenyibiotec.com/legal-notes.html#termsandconditions"
             target="_blank"><span>{{'submitBox.termsAndConditions' | cxTranslate}}</span></a>
        </span>
      </label>
      <mb-form-errors [control]="termsConditionsForm?.get(constants.TERMS_AND_CONDITIONS)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </form>


  <div class="col-12 mb-3 mb-consent-info mb-margin-top"
       data-cy="mb-consent-info">{{'submitBox.consentInfo' | cxTranslate}}
    <a class="mb-terms-link" href="https://www.miltenyibiotec.com/privacy-statement.html"
       target="_blank">{{'submitBox.privacyStatement' | cxTranslate}}</a>
  </div>
</div>
